export namespace MemoryActions {
  export class Reset {
    static readonly type = '[Memory] Reset';
    constructor() {}
  }

  export class Update {
    static readonly type = '[Memory] Update';
    constructor(public isFirstChapter: boolean, public logToConsole = false) {}
  }
}
